import React from 'react';
import { Paper, Box, Typography, Divider, Button, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, useTheme } from '@mui/material';
import { Undo, Redo, Save, Download, Print, FolderOpen, Image as ImageIcon, Inventory2, StarBorder } from '@mui/icons-material';

const TopBar = ({ onUndo, onRedo, onNew, onOpen, onEditTemplate, onImportPng, onSave, onDownload, onPrint, onPageSettings, onLoadFromInventory, onSaveAsTemplate, currentAsset, filters = [], onApplyFilter, selectedFilter, canApplyFilter = true }) => {
  const theme = useTheme();
  const [fileAnchor, setFileAnchor] = React.useState(null);
  const openFile = (e) => setFileAnchor(e.currentTarget);
  const closeFile = () => setFileAnchor(null);
  // Filters menu
  const [filterAnchor, setFilterAnchor] = React.useState(null);
  const openFilter = (e) => setFilterAnchor(e.currentTarget);
  const closeFilter = () => setFilterAnchor(null);
  const title = currentAsset?.name ? `Photo+ Ads — ${currentAsset.name}` : 'Photo+ Ads';

  return (
    <Paper sx={{ borderRadius: 0, bgcolor: theme.palette.background.paper, borderBottom: `1px solid ${theme.palette.divider}`, p: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="h6" sx={{ color: theme.palette.text.primary, fontWeight: 'bold' }} title={title}>
          {title}
        </Typography>
        <Divider orientation="vertical" flexItem sx={{ bgcolor: theme.palette.divider }} />
        <Button size="small" sx={{ color: theme.palette.text.primary }} onClick={openFile}>File</Button>
        <Menu anchorEl={fileAnchor} open={!!fileAnchor} onClose={closeFile}>
          <MenuItem onClick={() => { onNew?.(); closeFile(); }}>
            <ListItemIcon><span style={{ width: 18 }} /></ListItemIcon>
            <ListItemText primary="New" />
          </MenuItem>
          <MenuItem onClick={() => { onOpen?.(); closeFile(); }}>
            <ListItemIcon><FolderOpen fontSize="small" /></ListItemIcon>
            <ListItemText primary="Open" />
          </MenuItem>
          <MenuItem onClick={() => { onEditTemplate?.(); closeFile(); }}>
            <ListItemIcon><StarBorder fontSize="small" /></ListItemIcon>
            <ListItemText primary="Edit Template…" />
          </MenuItem>
          <MenuItem onClick={() => { onLoadFromInventory?.(); closeFile(); }}>
            <ListItemIcon><Inventory2 fontSize="small" /></ListItemIcon>
            <ListItemText primary="Load from Inventory…" />
          </MenuItem>
          <MenuItem onClick={() => { onImportPng?.(); closeFile(); }}>
            <ListItemIcon><ImageIcon fontSize="small" /></ListItemIcon>
            <ListItemText primary="Import PNG…" />
          </MenuItem>
          <MenuItem onClick={() => { onSave?.(); closeFile(); }}>
            <ListItemIcon><Save fontSize="small" /></ListItemIcon>
            <ListItemText primary="Save" />
          </MenuItem>
          <MenuItem onClick={() => { onSaveAsTemplate?.(); closeFile(); }}>
            <ListItemIcon><StarBorder fontSize="small" /></ListItemIcon>
            <ListItemText primary="Save as Template" />
          </MenuItem>
          <MenuItem onClick={() => { onDownload?.(); closeFile(); }}>
            <ListItemIcon><Download fontSize="small" /></ListItemIcon>
            <ListItemText primary="Download" />
          </MenuItem>
          <MenuItem onClick={() => { onPrint?.(); closeFile(); }}>
            <ListItemIcon><Print fontSize="small" /></ListItemIcon>
            <ListItemText primary="Print" />
          </MenuItem>
          <MenuItem onClick={() => { onPageSettings?.(); closeFile(); }}>
            <ListItemIcon><span style={{ width: 18 }} /></ListItemIcon>
            <ListItemText primary="Page Settings" />
          </MenuItem>
        </Menu>
        <Button size="small" sx={{ color: theme.palette.text.primary }}>Edit</Button>
        <Button size="small" sx={{ color: theme.palette.text.primary }}>Image</Button>
        <Button size="small" sx={{ color: theme.palette.text.primary }}>Layer</Button>
        <Button size="small" sx={{ color: theme.palette.text.primary }} onClick={openFilter} disabled={!canApplyFilter}>Filter</Button>
        <Menu anchorEl={filterAnchor} open={!!filterAnchor} onClose={closeFilter}>
          {filters.length === 0 && (
            <MenuItem disabled>
              <ListItemText primary="No filters available" />
            </MenuItem>
          )}
          {filters.map(f => (
            <MenuItem key={f.id} onClick={() => { onApplyFilter?.(f.id); closeFilter(); }} selected={selectedFilter === f.id}>
              <ListItemIcon><span style={{ width: 18 }} /></ListItemIcon>
              <ListItemText primary={f.label} />
            </MenuItem>
          ))}
        </Menu>
        <Button size="small" sx={{ color: theme.palette.text.primary }}>View</Button>
        <Box sx={{ flexGrow: 1 }} />
        <IconButton size="small" onClick={onUndo} sx={{ color: theme.palette.text.primary }}><Undo /></IconButton>
        <IconButton size="small" onClick={onRedo} sx={{ color: theme.palette.text.primary }}><Redo /></IconButton>
        <IconButton size="small" onClick={onSave} sx={{ color: theme.palette.text.primary }}><Save /></IconButton>
        <IconButton size="small" onClick={onDownload} sx={{ color: theme.palette.text.primary }}><Download /></IconButton>
      </Box>
    </Paper>
  );
};

export default TopBar;
